import './App.css';  
import React, { memo, lazy, useCallback, Suspense, useMemo } from "react";  
import { Box } from '@mui/material';

import { useGlobalState } from 'context/GlobalStateContext';

import { Fallback } from 'components/FallbackLoading'; 

const Template1 = lazy(() => import("template/template1/layout/index")); 
const PulseTemplate = lazy(() => import("template/pulse_template/layout/index")); 
const ShopyTemplate = lazy(() => import("template/shopy_template/layout/index")); 

/**
 * App component is the main entry point of the application.
 * It selects and renders a template based on the `codeShop` retrieved from the `SettingsApps` context.
 * The selected template is lazily loaded and displayed with a fallback message while loading.
 *
 * @author Helmi Ben Eroi
 * @date 2024-08-16
 *
 * @returns {JSX.Element} The main application component.
 */
function App() { 
const {
  templateData: {
    templateCode,  
  } = {}  
} = useGlobalState() || {};

const templates = {
  HORIZON:<Template1 /> ,
  PULSE:<PulseTemplate/>,//PulseTemplate
  SHOPY:<ShopyTemplate/>
}
 
  /**
   * Selects and renders the appropriate template based on the `codeShop`.
   * Uses `Suspense` to display a fallback message while the template is being loaded.
   *
   * @returns {JSX.Element} The selected template component with a loading fallback.
   */
  const Template = useCallback(({templateCode}) => {

    return (
      <Suspense fallback={<Box sx={{
        height:'100vh'
      }}><Fallback/></Box>}>
        {templates[templateCode ?? 'HORIZON'] ||  <> not found </>} 
      </Suspense>
    );
  }, []); 
    const template = useMemo(()=>{ return <Template templateCode={templateCode}/> },[templateCode])
  return (
    <div className={`App-${templateCode}`} id={'App'} data-testid={'App'}> 
      {template}
    </div>
  );
};

export default memo(App);
